import { Resources } from './types'

const resources: Resources = {
  apps: {
    general: 'https://www.swarm.com',
    swarm: 'https://app.swarm.com',
    staking: 'https://smt.swarm.com',
    vote: 'https://vote.swarm.com',
  },
  swarmX: {
    terms: {
      termsAndAgreements: 'http://docs.fundz.io',
      disclaimer: 'http://docs.fundz.io/',
    },
    docs: {
      kycSelect: 'https://docs.swarm.com/reference/kyc-select',
    },
  },
  iconsCdn: 'https://d153cgr8o6wwrb.cloudfront.net',
  tokenIconsCdn: 'https://cdn.jsdelivr.net/gh/atomiclabs/cryptocurrency-icons',
  trustwalletIconsCdn:
    'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains',
}

export default resources
